var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_leaveReason_form_newTitle"),
      widthClass: "max-1000",
      initData: _vm.LeaveReasonData,
      backgroundClass: "white",
      checkData: [
        "leave_reason_name",
        "sequence",
        "leave_reason_description",
        "leave_reason_code",
        "leave_type_uuid",
        "remarks",
      ],
    },
    on: {
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  { attrs: { align: "center", justify: "start" } },
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            bindData: _vm.LeaveReasonData.leave_reason_name,
                            maxlength: "100",
                            label: _vm.$t(
                              "label_essweb_leaveReason_form_leaveReasonNameLabel"
                            ),
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.LeaveReasonData.leave_reason_name = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_leaveReason_form_leaveTypeLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("v-autocomplete", {
                          attrs: {
                            items: _vm.leaveType,
                            "item-text": "leave_type_name",
                            "item-value": "uuid",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            dense: "",
                            placeholder: _vm.$t(
                              "label_essweb_leaveReason_form_leaveTypeLabel"
                            ),
                            filled: "",
                            "single-line": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.LeaveReasonData.leave_type_uuid,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.LeaveReasonData,
                                "leave_type_uuid",
                                $$v
                              )
                            },
                            expression: "LeaveReasonData.leave_type_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            maxlength: "10",
                            type: "number",
                            label: _vm.$t(
                              "label_essweb_leaveReason_form_sequenceLabel"
                            ),
                            rules: _vm.$GetRules(
                              ["_Number_negative", "_Length_Rules"],
                              [null, 10]
                            ),
                            isNotRequire: "",
                          },
                          model: {
                            value: _vm.LeaveReasonData.sequence,
                            callback: function ($$v) {
                              _vm.$set(_vm.LeaveReasonData, "sequence", $$v)
                            },
                            expression: "LeaveReasonData.sequence",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            label: _vm.$t(
                              "label_essweb_leaveReason_form_codeLabel"
                            ),
                            maxlength: "50",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          model: {
                            value: _vm.LeaveReasonData.leave_reason_code,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.LeaveReasonData,
                                "leave_reason_code",
                                $$v
                              )
                            },
                            expression: "LeaveReasonData.leave_reason_code",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            bindData:
                              _vm.LeaveReasonData.leave_reason_description,
                            maxlength: "500",
                            label: _vm.$t(
                              "label_essweb_leaveReason_form_descriptionLabel"
                            ),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.LeaveReasonData.leave_reason_description =
                                valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-sheet", { staticClass: "text--secondary" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "label_essweb_leaveReason_form_RemarkLabel"
                              )
                            )
                          ),
                        ]),
                        _c("v-textarea", {
                          attrs: {
                            rows: "5",
                            "no-resize": "",
                            maxlength: "500",
                            dense: "",
                            counter: "500",
                            "single-line": "",
                            filled: "",
                          },
                          model: {
                            value: _vm.LeaveReasonData.remarks,
                            callback: function ($$v) {
                              _vm.$set(_vm.LeaveReasonData, "remarks", $$v)
                            },
                            expression: "LeaveReasonData.remarks",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { newBtn: "" },
              on: {
                new: _vm.toNew,
                cancel: function ($event) {
                  return _vm.$toBack(_vm.isChanged)
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }